var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", [
        _c(
          "div",
          { staticClass: "btn-box" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.addtype } },
              [_vm._v(_vm._s(_vm.$t("hr.addtype")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-box mt20" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  "header-cell-style": { background: "#F2F2F2" },
                },
              },
              [
                _c("el-table-column", {
                  staticStyle: { "padding-left": "20px" },
                  attrs: { prop: "id", label: "ID", width: "50" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "name",
                    label: _vm.$t("hr.rankcategoryname"),
                    "min-width": "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "number",
                    label: _vm.$t("hr.ranknumber"),
                    "min-width": "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: _vm.$t("hr.state"), width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              "active-text": _vm.$t("hr.open"),
                              "inactive-text": _vm.$t("hr.close"),
                              "active-value": 1,
                              "inactive-value": 0,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.handleStatus(scope.row)
                              },
                            },
                            model: {
                              value: scope.row.status,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "status", $$v)
                              },
                              expression: "scope.row.status",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "address",
                    label: _vm.$t("public.operation"),
                    fixed: "right",
                    width: "160",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.deit(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("public.edit")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.delet(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("public.delete")))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page" },
          [
            _c("el-pagination", {
              attrs: {
                layout: "total, prev, pager, next, jumper",
                total: _vm.count,
                "page-size": _vm.pagesize,
                "current-page": _vm.page,
              },
              on: { "current-change": _vm.handleCurrentChange },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }